import React, {Fragment} from "react";
import QuestionCell from "./QuestionCell";
import {getAvgCellValue, getDays, getWeeks} from "./analyticsUtils";

export default function ({reportAnalytics, phase, question, reportType, showInlineComments, enablePtoAnalytics}) {
  return (
    <tr>
      <td>{question}</td>
      {
        getWeeks(reportAnalytics.weeks[phase.guid], phase, reportAnalytics, enablePtoAnalytics).map(week => (
          <Fragment>
            {getDays(week.days, phase, week, reportAnalytics, enablePtoAnalytics).map(day => (
              <Fragment>
                {reportAnalytics.reportMap[`${phase.guid}${week.weekNumber}${day}`]? (
                  <QuestionCell
                    key={`${question}${phase.guid}${week.weekNumber}${day}`}
                    reports={reportAnalytics.reportMap[`${phase.guid}${week.weekNumber}${day}`]}
                    question={question}
                    reportType={reportType}
                    showInlineComments={showInlineComments}
                  />
                ): <td></td>}
              </Fragment>
            ))}
            {
             !enablePtoAnalytics ? (reportAnalytics.weeklyAvgMap[`${phase.guid}#${question}#${week.weekNumber}`] && getAvgCellValue(reportType, reportAnalytics.weeklyAvgMap[`${phase.guid}#${question}#${week.weekNumber}`]) ?
                <td data-align="center">{getAvgCellValue(reportType, reportAnalytics.weeklyAvgMap[`${phase.guid}#${question}#${week.weekNumber}`])}</td>
                : <td data-align="center">N/R</td>): null
            }

          </Fragment>
        ))
      }
      {!enablePtoAnalytics ? (reportAnalytics.phaseAvgMap[`${phase.guid}#${question}#`] && getAvgCellValue(reportType, reportAnalytics.phaseAvgMap[`${phase.guid}#${question}#`]) ? (
        <td data-align="center"> {getAvgCellValue(reportType, reportAnalytics.phaseAvgMap[`${phase.guid}#${question}#`])}</td>
      ): <td data-align="center">N/R</td>): null}

      { !enablePtoAnalytics ? (reportAnalytics.totalAvgMap[`#${question}#`] && getAvgCellValue(reportType, reportAnalytics.totalAvgMap[`#${question}#`]) ? (
        <td data-align="center">{
          getAvgCellValue(reportType, reportAnalytics.totalAvgMap[`#${question}#`])
        }</td>
      ): <td data-align="center">N/R</td>): null}

    </tr>
  )
}
